import * as FindThalesMissingSegmentTask from "./podtemat7_tales_i_podobienstwo_types/FindThalesMissingSegmentTask";

// Jeden moduł obsługuje wszystkie tryby (singleSegment, partWhole, similarEasy, similarHard).
const MOD = FindThalesMissingSegmentTask;

const TYPES = {
  FindThalesSegmentTask: MOD,
  FindThalesPartWholeTask: MOD,
  FindSimilarBasesEasyTask: MOD,
  FindSimilarBasesHardTask: MOD,
  FindSimilarMissingBaseTask: MOD,
};

const MODE_BY_TYPE = {
  FindThalesSegmentTask: "singleSegment",
  FindThalesPartWholeTask: "partWhole",
  FindSimilarBasesEasyTask: "similarEasy",
  FindSimilarBasesHardTask: "similarHard",
  FindSimilarMissingBaseTask: "missingBase",
};

const resolve = (mod) => {
  if (!mod) return {};
  if (typeof mod.generateTask === "function") return mod;
  if (mod.default && typeof mod.default.generateTask === "function") return mod.default;
  return mod;
};

const moduleFor = (type) => resolve(TYPES[type] || MOD);

function generateTypedTask(type) {
  return resolve(MOD).generateTask({ mode: MODE_BY_TYPE[type], type });
}

export function generateTasks() {
  return Object.keys(MODE_BY_TYPE).map(generateTypedTask).filter(Boolean);
}

export function generateTask(type) {
  const taskType = type && MODE_BY_TYPE[type] ? type : "FindThalesSegmentTask";
  return generateTypedTask(taskType);
}

export function renderTask(task) {
  return moduleFor(task.type).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task.type).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task.type).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task.type).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task.type).renderExplanation(task);
}

export function renderUserAnswer(task, userAnswer) {
  const mod = moduleFor(task.type);
  return mod.renderUserAnswer ? mod.renderUserAnswer(userAnswer, task) : null;
}

export const talesPodobienstwoRegistry = Object.fromEntries(
  Object.keys(TYPES).map((type) => [
    type,
    {
      renderTask: (task) => renderTask({ ...task, type }),
      renderInput: (task, userAnswer, onChange, disabled) =>
        renderInput({ ...task, type }, userAnswer, onChange, disabled),
      checkAnswer: (task, userAnswer) => checkAnswer({ ...task, type }, userAnswer),
      renderAnswer: (task) => renderAnswer({ ...task, type }),
      renderExplanation: (task) => renderExplanation({ ...task, type }),
      renderUserAnswer: (userAnswer, task) => renderUserAnswer({ ...task, type }, userAnswer),
    },
  ])
);

export const registry = talesPodobienstwoRegistry;
